import request from '@/utils/request'
import { normalizeCommunityId } from '@/api/community/communityApi'

// 获取公告详情
export function getNoticeDetail(params) {
  return new Promise((resolve, reject) => {
    const query = { ...params }
    if (Object.prototype.hasOwnProperty.call(query, 'communityId')) {
      query.communityId = normalizeCommunityId(query.communityId)
      if (!query.communityId) {
        delete query.communityId
      }
    }
    request({
      url: '/notice.listNotices',
      method: 'get',
      params: query
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新公告
export function updateNotice(data) {
  return new Promise((resolve, reject) => {
    const payload = { ...data }
    if (Object.prototype.hasOwnProperty.call(payload, 'communityId')) {
      payload.communityId = normalizeCommunityId(payload.communityId)
    }
    request({
      url: '/notice.updateNotice',
      method: 'post',
      data: payload
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 上传图片
export function uploadNoticeImage(data) {
  return new Promise((resolve, reject) => {
    const payload = { ...data }
    if (Object.prototype.hasOwnProperty.call(payload, 'communityId')) {
      payload.communityId = normalizeCommunityId(payload.communityId)
      if (!payload.communityId) {
        delete payload.communityId
      }
    }
    request({
      url: 'uploadImage',
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      data: payload
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
